
import { emitEvent } from '../../utils/eventBus/vueEvent'

const IFRAME_EVENT_BY_VUE = 'iframe_event_by_vue'

export default {
  OUTPUT_RESULT: 'output_result',
  OUTPUT_CONSOLE: 'output_console',
  NEED_INPUT: 'need_input',
  RUN_PYTHON_CODE_LOCAL: 'run_python_code_local',

  // run code event
  RUN_CODE_RUN_RES: 'run_code_run_res',
  RUN_CODE_INPUT_RES: 'run_code_input_res',
  RUN_CODE_STOP_RES: 'run_code_stop_res',
  RUN_CODE_OUTPUTED: 'run_code_outputed',
  RUN_CODE_STOPED: 'run_code_stoped',

  // test code event
  TEST_CODE_RES: 'test_code_res',
  TEST_ENDED: 'test_ended',

  TEST_CODE_BY_HTTP: 'test_code_by_http',

  // ide event:
  // 填充ide中到代码
  IDE_SET_CODE: 'ide_set_code',
  // 从ide中获取代码
  IDE_GET_CODE: 'ide_get_code',
  // 设置ide theme
  IDE_SET_THEME: 'ide_set_theme',
  YOUTH_SET_CODE: 'youth_set_code',

  // ide event:
  PYTHON_SET_INPUT: 'python_set_input',

  // send Event like postMessage;
  emitIframeEvent: data => {
    emitEvent(IFRAME_EVENT_BY_VUE, { data, etype: 'vue' });
  },
  IFRAME_EVENT_BY_VUE,
};
